import {Component, Injector} from "@angular/core";
import {AbstractColumnComponent} from "./abstract-column.component";

/**
 * Define a column in a edit grid. The directives cellTemplate and headerTemplate can be used to define a template to render a column.
 * This component is not rendered as it is used as a metadata for the SearchGridComponent.
 */
@Component({
    selector: "wbo-column",
    template: ""
})
export class ColumnComponent extends AbstractColumnComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
